import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRewardRoute } from '@/common/reward/route.registry';
import { InjectionFeature } from '@/common/reward/types';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_QUEST } from './router';

export default registerRouteForModule(router);

registerRewardRoute(InjectionFeature.QuestBoost, {
    routeToIndexPage: () => ({ name: ROUTE_NAME_QUEST.BOOST.INDEX }),
    routeToInfoPage: boostId => ({ name: ROUTE_NAME_QUEST.BOOST.DETAIL, params: { boostId } })
});

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Quest',
        name: 'Quest',
        icon: 'fas fa-tasks'
    },
    {
        parent: 'Multiplayer.Quest',
        key: 'Type',
        name: 'Type',
        icon: 'fa fa-tags',
        route: { name: ROUTE_NAME_QUEST.TYPE.INDEX }
    },
    {
        parent: 'Multiplayer.Quest',
        key: 'Item',
        name: 'Item',
        icon: 'fa fa-check',
        route: { name: ROUTE_NAME_QUEST.ITEM.INDEX }
    },
    {
        parent: 'Multiplayer.Quest',
        key: 'Boost',
        name: 'Boost',
        icon: 'fas fa-syringe',
        route: { name: ROUTE_NAME_QUEST.BOOST.INDEX }
    }
]);
